/**
 * Join class names, dropping anything falsy.
 *
 * Four lines instead of `clsx`, because that is all this application asks of
 * it: there is no object or array syntax here, and a dependency whose whole
 * value is a conditional filter is a dependency to audit, licence-check and
 * upgrade for the rest of the product's life.
 */
export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}
